import React from "react";

import { addDoc, collection, getDocs, doc } from "@firebase/firestore";

import { firestore } from "../../firebase";
import { Box, Text } from "@chakra-ui/react";
import { Table } from "antd";
import Loader from "../../Components/Common/Loader";

const Leads = () => {
  const [leadData, setLeadData] = React.useState<any>([]);

  const [loading, setLoading] = React.useState(false);

  const getLeads = async () => {
    const ref = collection(firestore, "contact_form");

    try {
      setLoading(true);
      const docSnap: any = await getDocs(ref);

      if (docSnap.docs.length > 0) {
        let localDoc = [];
        for (const doc of docSnap.docs) {
          localDoc.push(doc.data());
        }

        setLeadData(localDoc);
      }
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getLeads();
  }, []);

  const colums = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Additional Info",
      dataIndex: "additionalInfo",
      key: "additionalInfo",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
  ];

  return (
    <Box>
      {loading && <Loader />}

      <Text fontSize="2xl" fontWeight="bold" mb="4">
        Leads
      </Text>

      <Table columns={colums} dataSource={leadData} />
    </Box>
  );
};

export default Leads;
